import React from 'react';
import './Education.css';

const Education = () => {
  return (
    <section
      id="education"
      className="education"
      style={{
        position: 'relative',
        background: '#edf5ff'
      }}
    >
      <div className="section-container">
        <h2 className="section-title">Education</h2>
        <div className="education-timeline">
          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <div className="timeline-header">
                <img src="/images/tu_graz_logo.png" alt="TU Graz Logo" className="institution-logo" />
                <div className="timeline-header-text">
                  <h3>Computer Science Bachelor's</h3>
                  <p className="timeline-institution">
                    <a href="https://www.tugraz.at/home" target="_blank" rel="noopener noreferrer">
                      TU Graz (Graz University of Technology)
                    </a>
                  </p>
                </div>
              </div>
              <p className="timeline-date">October 2023 - August 2026</p>
              <p className="timeline-description">
                I sucessfully completed my Bachelor's degree in Computer Science (Informatik) at Technical University of Graz, Austria, with distinction (grade: 1,5 - German Scale Grading from 1 to 5 with 1 being the best (sehr gut/very good)) Coursework includes human-computer interaction, computer vision, computer graphics, artificial intelligence, machine learning and other courses.
              </p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <div className="timeline-header">
                <img src="/images/oead_logo.png" alt="OeAD Logo" className="institution-logo" />
                <div className="timeline-header-text">
                  <h3>German Language Learning (A1-C1)</h3>
                  <p className="timeline-institution">
                    <a href="https://oead.at/en/" target="_blank" rel="noopener noreferrer">
                      OeAD GmbH – Agentur für Bildung und Internationalisierung
                    </a>
                  </p>
                </div>
              </div>
              <p className="timeline-date">June 2022 - January 2025</p>
              <p className="timeline-description">
                Completed German language courses from B1 to C1 level. Scores: B1 (score: 1 - sehr gut/very good), B2 (score: 1 - sehr gut/very good), C1 (score: 2 - gut/good). Located in Graz, Austria.
              </p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <div className="timeline-header">
                <img src="/images/aut_logo.svg" alt="AUT Logo" className="institution-logo" />
                <div className="timeline-header-text">
                  <h3>6 Semesters of computer science bachelor's</h3>
                  <p className="timeline-institution">
                    <a href="https://aut.ac.ir/en" target="_blank" rel="noopener noreferrer">
                      Amirkabir University of Technology (Tehran Polytechnic)
                    </a>
                  </p>
                </div>
              </div>
              <p className="timeline-date">September 2019 - September 2022</p>
              <p className="timeline-description">
                Completed 6 semesters with a GPA of 18.82/20. Coursework included Advanced Programming, Algorithm Design, Data Structures and Algorithms, Artificial Intelligence, Discrete Mathematics, Operating Systems, Linear Algebra, Computational Intelligence and other courses.
              </p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <div className="timeline-header">
                <img src="/images/sampad_logo.png" alt="Sampad Logo" className="institution-logo" />
                <div className="timeline-header-text">
                  <h3>High School Diploma</h3>
                  <p className="timeline-institution">Farzanegan 1 Highschool (NODET)</p>
                </div>
              </div>
              <p className="timeline-date">September 2013 - June 2019</p>
              <p className="timeline-description">
                National Organization for Development of Exceptional Talents (Sampad). Field of study: Mathematics and Physics. Final GPA: 19.84/20.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
